import { FormatDefinition } from '../../types';
import { jsonLogicFormatEntry } from './json-logic';
import { jsonFormatEntry } from './json';
import { richTextFormatEntry } from './rich-text';

export const customFormats: FormatDefinition[] = [
  jsonLogicFormatEntry,
  richTextFormatEntry,
  jsonFormatEntry,
];
